<script lang="ts">
  import type { ImageAsset } from '$lib/types/contentTypes';
  export let title: string;
  export let subHeading: string;
  export let image: ImageAsset;
  export let link: string;
  export let customClass: string = '';
  export let customImageClass: string = '';
  export let customTitleClass: string = '';
  export let description: string | undefined = undefined;
  export let horizontalSmallDevice: boolean = false;
  export let headingLevel: 'h1' | 'h3' = 'h3';
  export let cardSize: string = 'standard';

  const containerClass = horizontalSmallDevice
    ? 'grid grid-flow-col grid-cols-[2fr_3fr] gap-4 lg:grid-flow-row lg:grid-cols-[none] lg:gap-6'
    : 'flex flex-col gap-6 w-full';
  const imageClass = horizontalSmallDevice
    ? 'h-[6.25rem] w-full lg:h-[15rem]'
    : 'w-full h-auto min-h-[17rem]';
  const contentClass = horizontalSmallDevice ? 'gap-0 justify-center lg:gap-2' : 'gap-2';
  const subHeadingClass = horizontalSmallDevice ? 'text-xs lg:text-sm' : 'text-sm';
  const titleClass = horizontalSmallDevice ? 'text-normal lg:text-30' : 'text-30';
  const descriptionClass = horizontalSmallDevice ? 'text-xs lg:text-md' : 'text-md';
  const imageSizeParams = cardSize == 'large' ? 'w=1400&q=85&fm=webp' : 'w=600&q=85&fm=webp';
</script>

<a
  href={link !== null && link.includes('blogs') ? link.toLowerCase() : link}
  class="{containerClass} {customClass}"
>
  <div class="flex">
    <img
      src="{image.url}?{imageSizeParams}"
      alt={image?.description || image.title}
      loading="lazy"
      class="object-cover rounded-xxl self-center {imageClass} {customImageClass}"
    />
  </div>
  <div class="flex flex-col {contentClass}">
    <p class=" text-primary-500 font-semibold {subHeadingClass}">{subHeading}</p>
    <svelte:element
      this={headingLevel}
      class="text-gray-900 font-semibold {titleClass} {customTitleClass}">{title}</svelte:element
    >
    {#if description}
      <p class=" text-gray-600 font-medium {descriptionClass}">{description}</p>
    {/if}
  </div>
</a>
